import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/styles';
import { useAppContext } from '../../contexts/app';
import { myGroupsQuery } from '../../apollo/groups';
import HostGroup from '../host-group';
import HostUser from '../host-user';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  hostUser: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  hostGroup: {
    marginLeft: theme.spacing(0.5),
  },
}));

const FormNotificationsSummary = ({ event, isEventSeries }) => {
  const {
    values: { groupId, status, visibility, hostType },
  } = useFormikContext();
  const { isLoggedIn, loggedInUser } = useAppContext();
  const classes = useStyles();

  const { data: groupsData } = useQuery(myGroupsQuery, {
    skip: !isLoggedIn,
  });
  const group = useMemo(() => {
    if (!groupsData) {
      return null;
    }
    const groups = _get(groupsData, 'me.groups', []);
    return _find(groups, ({ id }) => id === groupId);
  }, [groupsData, groupId]);

  const sendToUserFollowers = useMemo(() => {
    // special event series logic doesnt send to user followers
    if (isEventSeries && hostType === 'Group') {
      return false;
    }
    return (status === 'PUBLISHED' || status === 'GROUP_PENDING') && visibility === 'PUBLIC';
  }, [status, visibility, isEventSeries, hostType]);

  const sendToGroupMembers = useMemo(() => {
    return group &&
      (status === 'PUBLISHED' || status === 'GROUP_PENDING') &&
      (visibility === 'PUBLIC' || visibility === 'GROUP');
  }, [status, visibility, group]);

  if (!isLoggedIn || status === 'DRAFT' || (event && event.status === 'PUBLISHED')) {
    return null;
  }

  return (
    <p className={classes.wrapper}>
      When published,{' '}
      {(sendToUserFollowers || sendToGroupMembers) ? (
        <Fragment>
          notifications will be sent{isEventSeries ? ' in batches' : ''} to
          {sendToUserFollowers && (
            <Fragment>
              {' '}followers of
              <HostUser user={loggedInUser} className={classes.hostUser} />
            </Fragment>
          )}
          {sendToUserFollowers && sendToGroupMembers && ' and '}
          {sendToGroupMembers && (
            <Fragment>
              {' '}members of <HostGroup group={group} className={classes.hostGroup} />
            </Fragment>
          )}
        </Fragment>
      ) : 'no notifications will be sent'}
      .
    </p>
  );
};

FormNotificationsSummary.propTypes = {
  event: PropTypes.object,
  isEventSeries: PropTypes.bool,
};

export default FormNotificationsSummary;
